module.exports = __webpack_public_path__ + "static/media/gi.b0015a50.svg";